import React from 'react'
import { Icon as IconType } from 'react-feather'

import { DocumentCardDataAttribute } from '@frame/types'

import { DeleteButton } from './delete-button'
import { Name } from './name'

type Props = {
  Icon: IconType
  name: string
  disabled?: boolean
  onDelete?: () => void
  setSelectedFileToRemove: () => void
}

export function Header({ Icon, name, disabled = false, onDelete, setSelectedFileToRemove }: Props) {
  return (
    <div className="flex w-full items-center justify-between">
      <div className="relative flex w-full min-w-0 items-center gap-2">
        <Icon data-cy={DocumentCardDataAttribute.ICON} className="flex-shrink-0 text-moss-500" width={30} height={30} />
        <Name>{name}</Name>
      </div>
      {onDelete && (
        <DeleteButton onDelete={onDelete} disabled={disabled} setSelectedFileToRemove={setSelectedFileToRemove} />
      )}
    </div>
  )
}
